import React from "react"
import PropTypes from "prop-types"
import { ArrowRightIcon } from "@heroicons/react/20/solid"

export const ButtonType = {
  solid:
    "text-white bg-red-300 hover:bg-red-400 active:bg-red-500 rounded-full transition ease-in-out duration-150",
  outline:
    "text-red-300 border-red-300 bg-white hover:text-red-400 hover:border-red-400 active:text-red-500 active:border-red-500 transition ease-in-out duration-150",
  ghost:
    "text-gray-500 hover:text-gray-900 transition ease-in-out duration-300",
}

export const ButtonSize = {
  none: "",
  sm: "py-2 px-4 text-sm font-medium tracking-wider",
  base: "py-2 px-5 text-lg font-medium tracking-wider",
  md: "py-3 px-6 text-xl font-medium tracking-wider",
  lg: "py-3 px-9 text-2xl font-medium tracking-wider",
  smOutline: "pt-2 pb-3 text-2xl font-bold border-b-[6px]",
  lgOutline: "pt-3 pb-5 text-4xl font-bold border-b-[8px]",
}

export function ButtonIcon({ children, size = "" }) {
  const arrowRightIcon =
    size === "smOutline" ? (
      <ArrowRightIcon height={20} />
    ) : (
      <ArrowRightIcon height={30} />
    )
  return (
    <Button size={size} type="outline" icon={arrowRightIcon}>
      {children}
    </Button>
  )
}

export function Button({
  children,
  className = "",
  icon,
  size = "md",
  type = "solid",
}) {
  const classNames = `${ButtonType[type]} ${ButtonSize[size]}`

  return icon ? (
    <button
      type="button"
      className={`inline-flex justify-center items-center ${classNames} ${className}`}
    >
      {children}
      <div className="ml-3">{icon}</div>
    </button>
  ) : (
    <button type="button" className={`${classNames} ${className}`}>
      {children}
    </button>
  )
}

ButtonIcon.propTypes = {
  children: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
}

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.element,
}
